import type { ProductImageEntry, ProductImageScenario } from "./types";

const entry = (
  id: string,
  scenario: ProductImageScenario,
  module: string,
  opens: string,
  setup: readonly string[],
  altSv: string,
  altEn: string,
  showsSv: string,
  showsEn: string,
  provesSv: string,
  provesEn: string,
): ProductImageEntry => ({
  id,
  module,
  area: "solution",
  opens,
  setup,
  scenario,
  visual: { variant: 0 },
  text: {
    sv: { alt: altSv, shows: showsSv, proves: provesSv },
    en: { alt: altEn, shows: showsEn, proves: provesEn },
  },
  use: ["pages/Plattform.tsx"],
});
const s4Sv = "Schema → rapport → vald, redan accepterad eCare-period";

export const REPORT_NEXT_CANDIDATE_CATALOGUE: readonly ProductImageEntry[] = [
  entry(
    "report.next.plan-performed-duration",
    "S4",
    "Rapport · Plan mot utfört",
    s4Sv + " → Plan mot utfört: nyckeltal",
    [
      "Öppna den sparade S4-rapporten och välj Plan mot utfört: nyckeltal",
      "Visa den parade jämförelsen för samma besök",
    ],
    "Rapportens parade staplar för planerad och utförd besökslängd",
    "The report's paired bars for planned and performed visit duration",
    "Två staplar jämför parad planerad tid med importerad utförd tid.",
    "Two bars compare paired planned time with imported performed time.",
    "Värdena kommer från rapportens sparade plan- och utförandebindningar för samma period.",
    "Values come from the report's saved planned and performed bindings for the same period.",
  ),
  entry(
    "report.next.plan-performed-starts",
    "S4",
    "Rapport · Starttider",
    s4Sv + " → Plan mot utfört: starttider",
    [
      "Öppna den sparade S4-rapporten och välj Plan mot utfört: starttider",
      "Fortsätt bara när båda native diagrammen innehåller mätta värden",
    ],
    "Rapportens diagram över avvikelser från planerad starttid",
    "The report's charts of deviations from planned start times",
    "Avsnittet visar hur tidigt eller sent besöken startade jämfört med planen.",
    "The section shows how early or late visits started compared with the plan.",
    "Diagrammen visas bara när importerade klockslag och täckning räcker för mätningen.",
    "Charts appear only when imported clocks and coverage support the measurements.",
  ),
  entry(
    "report.next.imported-continuity-chart",
    "S2",
    "Rapport · Kontinuitet",
    "Schema → färdig DEV-lösning → rapport → Kontinuitet",
    [
      "Öppna rapporten för en färdig CAIRE-lösning i DEV och välj Kontinuitet",
      "Fortsätt bara när den valda CAIRE-sidan har mätta kontinuitetsband",
    ],
    "Rapportens kontinuitetsfördelning för den valda Caire-lösningen",
    "The report's continuity distribution for the selected Caire solution",
    "Diagrammet visar hur många olika medarbetare brukarna möter i den valda lösningen.",
    "The chart shows how many different caregivers clients meet in the selected solution.",
    "Fördelningen kommer från den färdiga lösningens sparade kontinuitetsmått.",
    "The distribution comes from the completed solution's saved continuity metrics.",
  ),
  entry(
    "report.next.completed-caire-comparison",
    "S2",
    "Rapport · CAIRE-jämförelse",
    "Schema → färdig DEV-lösning → rapport → Caires schema mot referensen",
    [
      "Kräver en färdig CAIRE-lösning i DEV och en annan sparad referenslösning",
      "Fortsätt bara om den riktiga rapporten visar jämförelsediagrammet",
    ],
    "Rapportdiagram för en färdig Caire-lösning och dess referens",
    "Report chart for a completed Caire solution and its reference",
    "Avsnittet visar rapportens jämförelse när dess data innehåller en kvalificerad CAIRE-sida.",
    "The section shows the report's comparison when its data contains a qualified CAIRE side.",
    "Jämförelsen bygger på ett färdigt Caire-resultat och dess sparade referens för samma period.",
    "The comparison uses a completed Caire result and its saved reference for the same period.",
  ),
];
